import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useGetProjectQuery } from "../../features/projects/projectsApi";
import { useEditTaskMutation } from "../../features/tasks/tasksApi";
import { useGetTeamQuery } from "../../features/team/teamApi";

const Form = ({ task }) => {
  const [taskName, setTaskName] = useState(task.taskName);
  const [teamMember, setTeamMember] = useState(task.teamMember.name);
  const [projectName, setProjectName] = useState(task.project.projectName);
  const [deadline, setDeadline] = useState(task.deadline);

  const { data: project } = useGetProjectQuery(projectName, {
    skip: !projectName,
  });

  const { data: team } = useGetTeamQuery(teamMember, {
    skip: !teamMember,
  });

  const [editTask, { isLoading }] = useEditTaskMutation();

  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    editTask({
      id: task.id,
      taskName,
      teamMember: team[0],
      project: project[0],
      deadline,
    });
    navigate("/");
  };

  return (
    <form className="space-y-6" onSubmit={handleSubmit}>
      <div className="fieldContainer">
        <label for="lws-taskName">Task Name</label>
        <input
          type="text"
          name="taskName"
          id="lws-taskName"
          required
          value={taskName}
          placeholder="Implement RTK Query"
          onChange={(e) => setTaskName(e.target.value)}
        />
      </div>

      <div className="fieldContainer">
        <label>Assign To</label>
        <select
          name="teamMember"
          id="lws-teamMember"
          required
          value={teamMember}
          onChange={(e) => setTeamMember(e.target.value)}
        >
          <option value="" hidden selected>
            Select Job
          </option>
          <option>Sumit Saha</option>
          <option>Saad Hasan</option>
          <option>Akash Ahmed</option>
          <option>Md Salahuddin</option>
          <option>Riyadh Hassan</option>
          <option>Ferdous Hassan</option>
          <option>Arif Almas</option>
        </select>
      </div>
      <div className="fieldContainer">
        <label for="lws-projectName">Project Name</label>
        <select
          id="lws-projectName"
          name="projectName"
          required
          value={projectName}
          onChange={(e) => setProjectName(e.target.value)}
        >
          <option value="" hidden selected>
            Select Project
          </option>
          <option>Scoreboard</option>
          <option>Flight Booking</option>
          <option>Product Cart</option>
          <option>Book Store</option>
          <option>Blog Application</option>
          <option>Job Finder</option>
        </select>
      </div>

      <div className="fieldContainer">
        <label for="lws-deadline">Deadline</label>
        <input
          type="date"
          name="deadline"
          id="lws-deadline"
          required
          value={deadline}
          onChange={(e) => setDeadline(e.target.value)}
        />
      </div>

      <div className="text-right">
        <button type="submit" className="lws-submit" isLoading={isLoading}>
          Save
        </button>
      </div>
    </form>
  );
};

export default Form;
